import React from "react";
import "./billionaireHero.scss";

export default function BillionaireHero({ info, selectHandler, currentBill }) {
  const selectedBill = info.filter((item) => item.person.name == currentBill);
  const outputBill = selectedBill[0] || currentBill[0];

  return (
    <div className="card">
      <h2>{outputBill.person.name}</h2>
      <div>
        <p className='stats'>They're worth ${(outputBill.finalWorth * 1000000).toLocaleString()}</p>
        <p className='stats'>They made their money from {outputBill.industries}</p>
        <p className='stats'>Is ranked #{outputBill.rank} in forbes 400</p>
      </div>
      <form>
        <select name="billionaire" onChange={selectHandler}>
          {info.map((name) => {
            return (
              <option key={name.person.name} value={name.person.name}>
                {name.person.name}
              </option>
            );
          })}
        </select>
      </form>
    </div>
  );
}
